module.exports = __webpack_public_path__ + "media/images/metronic/social/instagram-5e0035c54efe9d99fd24a4cd2fd9ef9f.png";